import axios, { AxiosResponse } from 'axios'

import { Address } from './types'

const client = axios.create({
  baseURL: 'https://viacep.com.br/ws',
  headers: {
    'Content-Type': 'application/json'
  }
})

export const getAddressByZipCode = async (zipCode: string) =>
  await client.get<AxiosResponse<Address>>(`/${zipCode}/json/`)
